<script>
import {elementsSettingsDefaults, elementsSettingsDefinition, settingsSectionsDefinition} from "./settingsDefinition";
import {settings_empty, settings_invalid, settings_names} from "./settingsTrans";
import commonDefinitionMixin from "./commonDefinitionMixin";
import toaster from "../../common/toaster";
import {widgetSettingsAndPropertiesToQueryString} from '../../../../utils/widget';
import HeightCalculator from "../common/HeightCalculator";

let currentTypeDefinition_properties = null;
    let currentTypeDefinition_sections = null;

    export default {
        mixins: [
            commonDefinitionMixin,
        ],
        data: function () {
            return {
                t_loading: Lang.langGet("Loading..."),
                t_settings_of: Lang.langGet('Settings of :name', {name: ''}),
                t_user_properties: Lang.langGet("User Rights / Position"),
                t_plays_on: Lang.langGet("Plays on"),
                t_extended_properties: Lang.langGet("Extended Properties"),
                t_widget_settings: Lang.langGet("Widget Properties"),
                t_settings: Lang.langChoice("Setting|Settings", 2),
                t_template: Lang.langChoice("Template|Templates", 1),
                t_playback_properties: Lang.langGet("Playback Properties"),
                t_font: Lang.langGet("Font"),
                t_color: Lang.langGet("Color"),
                t_usergroups: Lang.langChoice("Usergroup|Usergroups", 2),
                t_usergroups_description: Lang.langGet("If you leave this empty, the element will be available for everyone."),
                t_strict_mode: Lang.langGet("Strict Mode"),
                t_strict_mode_description_tags: Lang.langGet("In \"Strict Mode\" elements must have ALL selected tags."),
                t_strict_mode_description: Lang.langGet("In \"Strict Mode\" elements must have ALL selected usergroups."),
                t_name: Lang.langGet("Name"),
                t_layers: Lang.langChoice("Layer|Layers", 2),
                t_tags: Lang.langChoice("Tag|Tags", 2),
                t_format: Lang.langGet("Ratio"),
                t_settings_readonly: Lang.langGet("You don't have the necessary usergroups or the \"Edit\"-Privilege to change settings."),
                t_left: Lang.langGet("Pixel from left"),
                t_top: Lang.langGet("Pixel from top"),
                t_size_width: Lang.langGet("Width in Pixel"),
                t_size_height: Lang.langGet("Height in Pixel"),
                t_width: Lang.langGet("Width"),
                t_height: Lang.langGet("Height"),
                t_locked: Lang.langGet("Locked"),
                t_trigger: Lang.langGet("Is trigger"),
                t_clickSync: Lang.langGet("Click / Sync settings"),
                t_locked_description: Lang.langGet("To prevent accidental modification you can lock this element."),
                t_edit_template: Lang.langGet("Edit Selected Template"),
                t_edit_campaign: Lang.langGet("Edit Selected Campaign"),
                t_description: Lang.langGet("Description / Comment"),
                t_description_with_trigger: Lang.langGet("Description / Comment / Trigger"),
                t_layer: Lang.langChoice("Layer|Layers", 2),
                t_local_copy: Lang.langGet("Create Local Copy"),
                t_not_enough_privileges: Lang.langGet("Not enough privileges to complete this action."),
                t_link_convert_failed: Lang.langGet("Failed to convert the link to a local copy!"),
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                t_creator_invalid: "",
                t_locked_ratio: Lang.langGet("Preserve Aspect Ratio"),
                t_collapse: Lang.langGet("Collapse"),
                t_expand: Lang.langGet("Expand"),

                colorpicker_primary: null,
                colorpicker_secondary: null,
                creator_errors: [],
                windowInfo: null,
                layoutInfo: null,
                dragdropCollapsed: false,
                settingsCollapsed: false,
                dragdropExists: true,
                active: this.startActive,
                setActiveBlocked: false,
                focused_element: null,
                element_to_be_scrolled: null,
                element_start_top: null,
                scrolled_name: "",
                scroll_start_offsettop: 0,
                old_text_direction: null,
                unsavedChanges: false,
                widget_settings: {},
                widget_properties: {},
                widget_default_query: {},
                loading: false,

                heightCalculator: new HeightCalculator()
            }
        },
        computed: {
            ratio: function () {
                let width = this.width,
                    height = this.height;

                if (this.width.length === 0) {
                    width = 1;
                }

                if (this.height.length === 0) {
                    height = 1;
                }

                return aspectRatio(width, height);
            },
            min_element_layer: function () {
                return -1;
            },
            locked: function () {
                return this.inner_properties.locked;
            },
            trigger: function () {
                return this.inner_properties.trigger;
            },
            readonly: function () {
                if (this.inner_element?.state === 'deleted') return true;
                if (this.inner_element?.state === 'tobedeleted') return true;
                return this.inner_properties.readonly;
            },
        },
        watch: {
            startActive: function () {
                this.active = this.startActive;
            },
            locked: function () {
                this.$nextTick(() => {
                    EaseEventBus.fire('reinitializeDragula');
                })
            },
            trigger: function () {
                this.$nextTick(() => {
                    EaseEventBus.fire('reinitializeDragula');
                })
            },
            readonly: function () {
                this.$nextTick(() => {
                    EaseEventBus.fire('reinitializeDragula');
                })
            },
            inner_properties: function () {
                if (this.inner_properties.type === 'widget') {
                    if (this.inner_properties.query_string === 'COPY') {
                        this.setWidgetQuery({copy: true});
                    } else if (this.inner_properties.query_string === 'CREATED') {
                        this.setWidgetQuery({copy: false});
                    }
                }
            },
            settingsCollapsed: function (val) {
                EaseEventBus.fire('settingsCollapsed', val);
            },
        },
        methods: {
            validateNumberProperties: function (element, validationResult, prefix) {
                let properties = {};
                if(element === this.inner_properties) {
                    properties = this.elementProperties();
                } else {
                    properties = this.getPropertiesForType(element.type, prefix);
                }
                let propertyNames = Object.keys(properties);

                let inner = {};
                let computedProps = {};
                if (this.frame) {
                    inner['inner_max_elementLeft'] = Math.round(this.frame.width / this.frame.ratio);

                    let normalizeWidth = 1, normalizeHeight = 1;
                    if (this.init) {
                        normalizeWidth = this.frame.width;
                        normalizeHeight = this.frame.height;
                    }
                    if (propertyNames.includes("elementLeft")) {
                        computedProps["elementLeft"] =  Math.max(0, Math.round(parseFloat(element.position.left) / parseFloat(this.frame.ratio) * normalizeWidth));
                        inner['inner_max_elementLeft'] = Math.round(this.frame.width / this.frame.ratio);
                    }
                    if (propertyNames.includes("elementTop")) {
                        computedProps["elementTop"] =   Math.max(0, Math.round(parseFloat(element.position.top) / parseFloat(this.frame.ratio) * normalizeHeight));
                        inner['inner_max_elementTop'] = Math.round(this.frame.height / this.frame.ratio);
                    }
                    if (propertyNames.includes("elementWidth")) {
                        computedProps["elementWidth"] = Math.max(0, Math.round(parseFloat(element.size.width) / parseFloat(this.frame.ratio) * normalizeWidth));
                        inner['inner_max_elementWidth'] = Math.round(this.frame.width / this.frame.ratio) - computedProps["elementLeft"];
                    }
                    if (propertyNames.includes("elementHeight")) {
                        computedProps["elementHeight"] = Math.max(0, Math.round(parseFloat(element.size.height) / parseFloat(this.frame.ratio) * normalizeHeight));
                        inner['inner_max_elementHeight'] = Math.round(this.frame.height / this.frame.ratio) - computedProps["elementTop"];
                    }

                    if (propertyNames.includes("width")) computedProps["width"] = this.width;
                    if (propertyNames.includes("height")) computedProps["height"] = this.height;
                }

                if (propertyNames.includes("display_runs")) computedProps["display_runs"] = element.duration_type === 2 ? element.display_runs : 1;

                for (const key of propertyNames) {
                    if (computedProps[key] == null && properties[key].computed) {
                        computedProps[key] = element;
                        _.each(properties[key].computed.split("."), (part) => {
                            computedProps[key] = computedProps[key][part];
                        });
                    }

                    let value = computedProps[key] != null ? computedProps[key] : (element[key] != null ? element[key] : undefined);
                    let limits = this.getFieldLimits(key, element.type);

                    // WORKAROUND - pdf page field cannot be invalid because it's caught at commonNoCollapseSettings > getGuardedPageValue
                    if (element.type === 'pdf') {
                        if (key === 'page_from' || key === 'page_to') {
                            continue;
                        }
                    }

                    if(limits) {
                        if(limits.color && typeof value === 'string') {
                            value = parseInt(value.replace('#', ''), 16);
                        }

                        let code = key;
                        let props = ['elementLeft', 'elementTop', 'elementRight', 'elementBottom', 'elementWidth', 'elementHeight'];
                        if(props.includes(key)) {
                            code = code.replace('element', '').toLowerCase();
                        }

                        if(isNaN(value) || value === '' || value === null || value === undefined) {
                            if(value !== '' && value != null) {
                                validationResult.errors.push(Lang.langGet(settings_invalid[code]));
                            } else if(!limits.empty) {
                                validationResult.errors.push(Lang.langGet(settings_empty[code]));
                            }
                        } else {
                            let bounds = this.getFieldBounds(limits, element, inner);
                            if(value > bounds.max || value < bounds.min) {
                                validationResult.valid = false;
                                let error = Lang.langGet(settings_names[code]);
                                if(bounds.max < Number.MAX_SAFE_INTEGER) {
                                    error += Lang.langGet(" is outside of the valid limits. Minimum: :min, maximum: :max", {'min': bounds.min, 'max': bounds.max});
                                } else {
                                    error += Lang.langGet(" is outside of the valid limits. Minimum: :min", {'min': bounds.min});
                                }
                                validationResult.errors.push(error);
                                return validationResult;
                            }
                        }
                    }
                }

                return validationResult;
            },
            scrolled: function () {
                if (this.element_to_be_scrolled !== null && this.element_start_top !== null) {
                    var top = this.element_start_top - (this.$refs.scrollBox.scrollTop - this.scroll_start_offsettop);
                    this.element_to_be_scrolled.style.top = top + "px";

                    var app = document.getElementById('app').getBoundingClientRect();
                    var scrollBox = this.$refs.scrollBox.getBoundingClientRect();
                    if (top < scrollBox.top - app.top ||
                        top - this.focused_element.getBoundingClientRect().height > scrollBox.top - app.top + scrollBox.height) {
                        var el = this.element_to_be_scrolled;
                        this.$refs.scrollBox.click();
                        if (this.focused_element) {
                            this.focused_element.blur();
                        }
                        if (this.scrolled_name === 'datepicker')
                            el.remove();
                    }
                }
            },
            initToBeScrolled: function (type, id) {
                var classnameToBeScrolled = "";
                if (type === 'datepicker') {
                    this.focused_element = document.getElementById(id);
                    classnameToBeScrolled = "datepicker-dropdown";
                } if (type === 'colorpicker') {
                    this.focused_element = document.getElementById("colorinput-" + id);
                    classnameToBeScrolled = "colorpicker-" + id;
                }
                this.scrolled_name = type;

                this.element_to_be_scrolled = null;
                this.scroll_start_offsettop = this.$refs.scrollBox.scrollTop;
                var elements = document.getElementsByClassName(classnameToBeScrolled);
                if (this.focused_element && elements && elements[0]) {
                    let rect = this.focused_element.getBoundingClientRect();
                    this.element_start_top = rect.top + rect.height;
                    this.element_to_be_scrolled = elements[0];
                }
                this.scrolled();
            },
            leaveElementToBeScrolled: function () {
                this.element_start_top = null;
                this.element_to_be_scrolled = null;
            },
            settingsStyle(forceRecalculation) {
                const height = this.settingsHeight(forceRecalculation);

                return {
                    height: height + 'px',
                }
            },
            settingsHeight(forceRecalculation) {
                const dragdropHeight = $('#dragdrop').height() ?? 0;
                const collapsed = dragdropHeight < 50;

                this.heightCalculator.memorizeHeights(forceRecalculation);
                const config = {
                    mode: this.mode,
                    grid: this.grid,
                    collapsed,
                    fullSize: !this.dragdropExists
                };

                this.heightCalculator.updateConfig(config);
                const height = this.heightCalculator.execute('settings');
                // console.log(`Height of Settings recalculated to ${height}`);
                return height;
            },
            is_collapsed: function () {
                let content = this.$refs['content'];
                if (content) {
                    if (content.style.display === 'none') {
                        return true;
                    }
                }
                return false;
            },
            toggle: function (collapsed) {
                if (this.is_collapsed() !== collapsed) {
                    let toggleButton = this.$refs['ibox-toggle'];
                    if (toggleButton) {
                        this.setActiveBlocked = true;
                        toggleButton.click();
                        this.setActiveBlocked = false;
                    }
                }
            },
            setActive: function () {
                if (!this.setActiveBlocked) {
                    this.setActiveBlocked = true;
                    this.active = true;
                    this.toggle(false);
                    EaseEventBus.fire('settingsActive');
                    this.setActiveBlocked = false;
                }
            },
            sectionAvailable(section) {
                if (section === 'widget') {
                    if (this.inner_properties.type==='widget') return true;
                }

                if (currentTypeDefinition_sections === null) {
                    return null;
                }
                return currentTypeDefinition_sections[section];
            },
            loadDefinitionForType: function(type, prefix) {
                let definition = this.getDefinitionForType(type, prefix);
                currentTypeDefinition_properties = definition['properties'];
                currentTypeDefinition_sections = definition['sections'];

                if(type === 'widget') {
                    this.fetchWidget(prefix);
                }
            },
            is_selectable_layer: function (id) {
                let layer = this.getLayerNr([String(id)])[0];
                return layer < this.min_element_layer || this.min_element_layer === -1;
            },
            is_disabled_layer: function (optiondata, width, height, ignore) {
                if(ignore === true) {
                    return false;
                }

                let arOptiondata = aspectRatio(optiondata.width, optiondata.height),
                    arIndividual = aspectRatio(width, height);

                return arOptiondata !== arIndividual;
            },
            elementProperties: function () {
                return currentTypeDefinition_properties;
            },
            getPropertiesForType: function (type, prefix) {
                let properties = [];
                if (elementsSettingsDefinition[type] !== undefined && elementsSettingsDefinition[prefix + type] !== undefined) {
                    Object.assign(properties, elementsSettingsDefinition[type], elementsSettingsDefinition[prefix + type]);
                } else if (elementsSettingsDefinition[type] !== undefined) {
                    properties = elementsSettingsDefinition[type];
                } else if (elementsSettingsDefinition[prefix + type] !== undefined) {
                    properties = elementsSettingsDefinition[prefix + type];
                }
                return properties;
            },
            getDefinitionForType: function (type, prefix) {
                let properties = [];
                if (type === undefined) {
                    return properties;
                }

                properties = this.getPropertiesForType(type, prefix);

                let sections = [];
                for (const [section_name, section_properties] of Object.entries(settingsSectionsDefinition)) {
                    for (const [section_property, property_occurence] of Object.entries(section_properties)) {
                        if (Object.keys(properties).includes(section_property)) {
                            if (property_occurence === 1 || Object.keys(property_occurence).includes(prefix.slice(1))) {
                                sections[section_name] = 1;
                                break;
                            }
                        }
                    }
                }

                return {
                    'properties': properties,
                    'sections': sections
                }
            },
            defaultValue: function (type, field) {
                if (type in elementsSettingsDefaults && field in elementsSettingsDefaults[type]) {
                    return elementsSettingsDefaults[type][field];
                } else if ("default" in elementsSettingsDefaults && field in elementsSettingsDefaults["default"]) {
                    return elementsSettingsDefaults["default"][field];
                }
                return "";
            },
            initializeColorpickers: function () {
                // Initialize primary color picker for the following elements
                let props = Object.keys(this.elementProperties());

                if (props.includes('primary_color') || props.includes('text_color') || props.includes('primary_text_color')) {
                    this.colorpicker_primary = $(this.$el).find('.colorpicker-component.primary.enabled').colorpicker({
                        format: 'hex',
                        color: this.inner_primary_color,
                        customClass: 'colorpicker-' + 'primary'
                    }).on('changeColor', () => {
                        if (this.colorpicker_primary !== null && this.colorpicker_primary.colorpicker !== undefined) {
                            const val = this.colorpicker_primary.colorpicker('getValue');
                            if(val) {
                                let value = this.formatColor(val);
                                EaseEventBus.fire('innerFieldValueChange', ['primary_color', value]);
                                if (value !== val) {
                                    this.colorpicker_primary.colorpicker('setValue', value);
                                }
                            } else {
                                this.colorpicker_primary.colorpicker('setValue', this.inner_primary_color);
                            }
                        }
                    });
                }

                // Initialize secondary color picker for the following elements
                if (props.includes('secondary_color') || props.includes('secondary_text_color')) {
                    this.colorpicker_secondary = $(this.$el).find('.colorpicker-component.secondary.enabled').colorpicker({
                        format: 'hex',
                        color: this.inner_secondary_color,
                        customClass: 'colorpicker-' + 'secondary'
                    }).on('changeColor', () => {
                        if (this.colorpicker_secondary !== null && this.colorpicker_secondary.colorpicker !== undefined) {
                            const val = this.colorpicker_secondary.colorpicker('getValue');
                            if(val) {
                                let value = this.formatColor(val);
                                EaseEventBus.fire('innerFieldValueChange', ['secondary_color', value]);
                                if (value !== val) {
                                    this.colorpicker_secondary.colorpicker('setValue', value);
                                }
                            } else {
                                this.colorpicker_secondary.colorpicker('setValue', this.inner_secondary_color);
                            }
                        }
                    });
                }
            },
            fetchWidget: function (prefix) {
                let widget_id = this.inner_properties.id;
                if(this.widget_settings.hasOwnProperty(widget_id)) {
                    this.determineDynamicTypeDefinition(prefix)
                } else {
                    this.loading = true;
                    axios.get('/administration/widget/get/' + Laravel.activeProject + '/' + widget_id).then((response) => {
                        let widget_definition = response.data.data;
                        this.widget_settings[widget_id] = [];
                        this.widget_properties[widget_id] = [];
                        if(widget_definition) {
                            if(widget_definition.settings) {
                                this.widget_settings[widget_id] = (widget_definition.settings);
                            }
                            if(widget_definition.properties) {
                                this.widget_properties[widget_id] = (widget_definition.properties);
                            }
                            if(widget_definition.query_string) {
                                this.widget_default_query[widget_id] = widget_definition.query_string;
                            }
                        }

                        this.determineDynamicTypeDefinition(prefix)
                        this.loading = false;
                    }).catch((error) => {
                        this.loading = false;
                        console.error(error);
                        if (error.response.status === 401) {
                            window.location = '/login';
                        }

                        toaster.error(this.t_load_widgets_failed);
                    });
                }
            },
            fetchWidget_onlySettingsProperties: function (data) {
                if(this.widget_settings.hasOwnProperty(data.widget_id)) {
                    EaseEventBus.fire('fetched_widget', data);
                } else {
                    this.loading = true;
                    axios.get('/administration/widget/get/' + Laravel.activeProject + '/' + data.widget_id).then((response) => {
                        let widget_definition = response.data.data;
                        this.widget_settings[data.widget_id] = [];
                        this.widget_properties[data.widget_id] = [];
                        if(widget_definition) {
                            if(widget_definition.settings) {
                                this.widget_settings[data.widget_id] = (widget_definition.settings);
                            }
                            if(widget_definition.properties) {
                                this.widget_properties[data.widget_id] = (widget_definition.properties);
                            }
                            if(widget_definition.query_string) {
                                this.widget_default_query[data.widget_id] = widget_definition.query_string;
                            }
                        }

                        this.loading = false;
                        EaseEventBus.fire('fetched_widget', data);
                    }).catch((error) => {
                        this.loading = false;
                        console.error(error);
                        if (error.response.status === 401) {
                            window.location = '/login';
                        }

                        toaster.error(this.t_load_widgets_failed);
                    });
                }
            },
            determineDynamicTypeDefinition: function (prefix) {
                let widget_id = this.inner_properties.id;
                let typeDefinition_properties = {};
                let typeDefinition_sections = {};
                Object.keys(currentTypeDefinition_properties).forEach(function (name) {
                    typeDefinition_properties[name] = {};
                    typeDefinition_properties[name] = Object.assign(typeDefinition_properties[name], currentTypeDefinition_properties[name]);
                });
                Object.keys(currentTypeDefinition_sections).forEach(function (name) {
                    typeDefinition_sections[name] = {};
                    typeDefinition_sections[name] = Object.assign(typeDefinition_sections[name], currentTypeDefinition_sections[name]);
                });
                currentTypeDefinition_properties = null;
                currentTypeDefinition_sections = null;

                typeDefinition_sections['widget'] = 1;
                _.each(Object.keys(this.widget_settings[widget_id] ?? {}), function(key) {
                    typeDefinition_properties[key] = { "edit_rights": "basic" };
                });

                _.each(this.widget_properties[widget_id], (val, key) => {
                    if(key === 'widget-has-length' && prefix !== 't_') {
                        typeDefinition_properties['display_runs'] = { "edit_rights": "advanced", "computed": "display_runs" };
                        if (this.inner_properties.display_runs === undefined) {
                            Vue.set(this.inner_properties, 'duration_type', 2);
                            Vue.set(this.inner_properties, 'display_runs', 1);
                        }
                    }
                    if(key === 'widget-can-scroll') {
                        typeDefinition_properties['scroll_speed'] = { "edit_rights": "advanced" };
                        if (this.inner_properties.scroll_speed === undefined) {
                            Vue.set(this.inner_properties, 'scroll_speed', 0);
                        }
                    }
                    if(key === 'widget-no-background') {
                        typeDefinition_properties['iframe_transparent'] = { "edit_rights": "advanced" };
                        if (this.inner_properties.iframe_transparent === undefined) {
                            Vue.set(this.inner_properties, 'iframe_transparent', 0);
                        }
                    }
                });
                currentTypeDefinition_properties = typeDefinition_properties;
                currentTypeDefinition_sections = typeDefinition_sections;
            },
            showMedia_WidgetAddQuery: function (data) {
                data.original = data.original ? data.original + this.getWidgetQuery(this.inner_properties) : '';
                EaseEventBus.fire('showMedia', data);
            },
            setWidgetQuery: function (data=null) {
                if ( this.inner_properties.id in this.widget_settings) {
                    this.inner_properties['query_string'] = this.getWidgetQuery(this.inner_properties);
                } else if (data === null) {
                    let fetch_data = {
                        widget_id:  this.inner_properties.id,
                        type: 'setWidgetQuery',
                    }
                    this.fetchWidget_onlySettingsProperties(fetch_data);
                }
            },
            newStructureSetWidgetQuery: function (data) {
                if (data.structure.id in this.widget_settings) {
                    data.structure['query_string'] = data.default_query ? this.widget_default_query[data.structure.id] : this.getWidgetQuery(data.structure);
                    EaseEventBus.fire('newStructure_AddedWidgetQuery', data)
                } else if (!('type' in data)) {
                    data.widget_id = data.structure.id;
                    data.type = 'newStructureSetWidgetQuery';
                    this.fetchWidget_onlySettingsProperties(data);
                }
            },
            getWidgetQuery: function(data) {
                return widgetSettingsAndPropertiesToQueryString(this.widget_settings[data.id], data);
            }
        },
        mounted: function () {
            EaseEventBus.listen('windowInfo', (data) => {
                this.windowInfo = _.extend({}, this.windowInfo, data);
            });
            EaseEventBus.listen('layoutInfo', (data) => {
                this.layoutInfo = _.extend({}, this.layoutInfo, data);
            });

            EaseEventBus.listen('dragdropActive', () => {
                this.active = false;
            });
            EaseEventBus.listen('dragdropDoesNotExist', () => {
                this.dragdropExists = false;
            });

            EaseEventBus.listen('settingsActive', () => {
                this.setActive();
            });

            EaseEventBus.listen('showMedia_WidgetAddQuery', (data) => {
                if (this.widget_settings.hasOwnProperty(this.inner_properties.id)) {
                    this.showMedia_WidgetAddQuery(data);
                } else {
                    data.type = 'show-media';
                    this.fetchWidget_onlySettingsProperties(data);
                }
            });
            EaseEventBus.listen('fetched_widget', (data) => {
                if (!data || !data.type) {
                    return;
                }
                if (data.type === 'show-media') {
                    delete data.type;
                    this.showMedia_WidgetAddQuery(data);
                } else if (data.type === 'setWidgetQuery') {
                    this.setWidgetQuery(data);
                } else if (data.type === 'newStructureSetWidgetQuery') {
                    this.newStructureSetWidgetQuery(data);
                }
            });
            EaseEventBus.listen('newStructure_SetWidgetQuery', (data) => {
                this.newStructureSetWidgetQuery(data);
            })
            EaseEventBus.listen('setWidgetQuery', () => {
                this.setWidgetQuery();
            })
        }
    }
</script>
